import ALERT_TYPES from "./users.alert.types"

class Alert {
 	 [x: string]: any;
 	 static $inject = ['$location', '$translate', '$stateParams', 'UsersAlertPendingService', 'UsersAlertService', 'AccountSettingsService', 'Router'];
    constructor($location, $translate, $stateParams, UsersAlertPendingService, UsersAlertService, AccountSettingsService, Router) {
        this.$translate = $translate;
        this.$location = $location;
        this.$stateParams = $stateParams;
        this.UsersAlertPendingService = UsersAlertPendingService;
        this.UsersAlertService = UsersAlertService;
        this.AccountSettingsService = AccountSettingsService;
        this.router = Router;
    }

    $onInit() {
        this.changedPlan = this.$stateParams.changedPlan;
        this.newInvitation = this.$stateParams.newInvitation;

        this.$location.search('changedPlan', null);
        this.$location.search('newInvitation', null);

        this.UsersAlertPendingService.onInit();

        if (!this.UsersAlertPendingService.isLocalhost()) {
          this.UsersAlertPendingService.getRequest().then((paymentRequest) => {
            if (paymentRequest.pending)
              this.UsersAlertService.prependAlert(ALERT_TYPES.changePlanPending);
            else if (this.changedPlan)
              this.UsersAlertService.prependAlert(ALERT_TYPES.changePlanSuccess);
            else if (this.newInvitation)
              this.UsersAlertService.prependAlert(ALERT_TYPES.invitationSuccess);

            this.AccountSettingsService.getSubscription().subscribe((subscription) => {
              if (subscription.status === "TRIAL") return;

              if (this.hasSlots())
                this.UsersAlertService.appendAlert(this.getSlots() === 1 ? ALERT_TYPES.oneFreeSlot : ALERT_TYPES.manyFreeSlots);
              else
                this.UsersAlertService.appendAlert(ALERT_TYPES.noFreeSlots);
            });
          });
        }
    }

    $onDestroy() {
        this.UsersAlertService.clear();
        this.UsersAlertPendingService.onDestroy();
    }

    getSlots() {
        return this.userStats.limit - this.userStats.activeCount - this.userStats.pendingCount;
    }

    hasSlots() {
        return this.getSlots() > 0;
    }

    hasAlerts() {
        return this.UsersAlertService.hasAlerts();
    }

    getAlert() {
        return this.UsersAlertService.getAlert();
    }

    deleteAlert() {
        this.UsersAlertService.deleteAlert();
    }

    clearAlerts() {
        this.UsersAlertService.clear();
    }

    goTo(url) {
      this.router.navigateByUrl(url);
    }
}

export default {
    controller: Alert,
    template : require('./users.alert.html'),
    bindings: { userStats: '<' }
};
